import './CompensationHistoryNonIFS.scss'
import { NavigateFunction } from 'react-router-dom';
import { useCompensationHistoryNonIFS } from './useCompensationHistoryNonIFS';
import AppLoader from '../AppCommon/AppLoader/AppLoader';
import CompensationHistorySearch from '../../components/CompensationHistorySearch/CompensationHistorySearch';
import { AppNotifications } from '../AppNotifications/AppNotifications';
import CompensationHistoryGridResults from '../CompensationHistoryGridResults/CompensationHistoryGridResults';
import { HISTORY_VIEW } from '../../constants/common';

interface Props {
    navigate: NavigateFunction;
}

const CompensationHistoryNonIFS = ({navigate}: Props) => {
    const {
        historyContext,
        searchFields,
        searchResults,
        showSearchResults,
        handleOnClickClear,
        handleOnClickSearch,
        setSearchFields,
        t
    } = useCompensationHistoryNonIFS()

    return (
        historyContext.loading.history ? (
            <AppLoader />
        ) : (
            <div className="c-comp-hist-non-ifs">
                <AppNotifications 
                    style={{ marginBottom: '3rem' }}
                />
                <h1 className="h-title h-title-hist">{t('titles.history.nonIfs')}</h1>
                <CompensationHistorySearch
                    fields={searchFields}
                    searchButtonDisabled={false}
                    handleOnClickClear={handleOnClickClear}
                    handleOnClickSearch={handleOnClickSearch}
                    setFields={setSearchFields}       
                />
                <div className="c-comp-hist-search-results">
                    {showSearchResults && (
                        <>
                            <hr />
                            <h1 className="h-title">{t('titles.history.nonIfsSearchResults')}</h1>
                            <CompensationHistoryGridResults 
                                handleOnClickSearch={handleOnClickSearch}
                                rows={searchResults}
                                navigate={navigate}
                                historyView={HISTORY_VIEW.nonIfs}
                                searchFields={searchFields}
                            />
                        </>
                    )}
                </div>
            </div>
        )       
    );  
};

export default CompensationHistoryNonIFS;

